import React from 'react';

interface PageControlsProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * PageControls — Toolbar strip below PageHeader for filters, search, view toggles, sort.
 * Inherits horizontal padding from parent container.
 */
export function PageControls({ children, className = '' }: PageControlsProps) {
  return (
    <div
      className={`page-controls shrink-0 border-b border-[var(--border-default)] ${className}`.trim()}
      style={{ paddingTop: 6, paddingBottom: 6 }}
    >
      <div className="flex items-center justify-end gap-2">
        {children}
      </div>
    </div>
  );
}

export default PageControls;
